import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/lead-gen/advisors')({
  head: () => buildHead('/products/lead-gen/advisors'),
});
